/**
 * Shared landing-page content container. Sections 1, 2 and 4 all centre their content on
 * this one measure; horizontal padding lives on the section so full-bleed backgrounds keep
 * working. At the 1920px design width the container fills the viewport (section padding
 * `md:px-10` is the remaining inset).
 */
export const LANDING_SECTION_PAD_CLASS = "px-6 md:px-10";
export const LANDING_CONTAINER_CLASS = "mx-auto w-full max-w-[1920px]";

/** Shared content measure — S1 hero title block and S4 CTA card (heading + portrait + quote). */
export const LANDING_CONTENT_MEASURE_CLASS = "mx-auto w-full max-w-[1440px]";

/**
 * Figma site header (3345:14467): 24px padding + 46px CTA. Used by the dev-preview
 * topbar and as the fallback when the host page has no measurable nav — in Webflow the
 * real nav height is measured from the host `.w-nav` (see use-host-nav-height.ts).
 */
export const LANDING_NAV_HEIGHT_PX = 94;

export const LANDING_NAV_HEIGHT_STYLE = {
	"--landing-nav-height": `${LANDING_NAV_HEIGHT_PX}px`,
} as const;

/** Desktop sticky stage: pin below the nav and fill the remaining viewport. */
export const LANDING_STICKY_BELOW_NAV_CLASS =
	"sticky top-[var(--landing-nav-height)] h-[calc(100svh-var(--landing-nav-height))]";
